import React from 'react';
import { Link } from 'react-router-dom';
import { IconWifi, IconDownload, IconUpload } from './PlanIcons';
import { buildWhatsAppPlanUrl } from '../utils/whatsapp';
import './PlanosAvulsos.css';

export const PLANOS_AVULSOS = [
  { numero: '300', unidade: 'Mega', velocidade: '300 Mega', precoInteiro: '59', precoCentavos: '99', nota: 'Pago até o dia 5 · R$ 79,99 se pago após o dia 5', idealPara: 'Navegação e redes sociais' },
  { numero: '800', unidade: 'Mega', velocidade: '800 Mega', precoInteiro: '99', precoCentavos: '90', idealPara: 'Home office e streaming' },
  { numero: '900', unidade: 'Mega', velocidade: '900 Mega', precoInteiro: '119', precoCentavos: '90', destaque: true, idealPara: 'Várias pessoas conectadas' },
  { numero: '1', unidade: 'Giga', velocidade: '1 Giga', precoInteiro: '129', precoCentavos: '90', idealPara: 'Gamers e criadores de conteúdo' },
];

function PlanosAvulsos({ showViewAllLink = false }) {
  return (
    <>
      <div className="avulsos-grid">
        {PLANOS_AVULSOS.map((plano) => (
          <div className={`avulso-card ${plano.destaque ? 'avulso-card--destaque' : ''}`} key={plano.numero}>
            {plano.destaque && <span className="avulso-card__ribbon">Melhor Oferta!</span>}
            <div className="avulso-card__header">
              <span className="avulso-card__numero">{plano.numero}</span>
              <span className="avulso-card__unidade-pill">{plano.unidade}</span>
            </div>
            <div className="avulso-card__body">
              {plano.idealPara && <p className="avulso-card__ideal">Ideal para {plano.idealPara}</p>}
              <ul className="avulso-card__specs">
                <li><IconWifi width={18} height={18} />Wi-Fi Incluso</li>
                <li><IconDownload width={18} height={18} />{plano.velocidade} de Download</li>
                <li><IconUpload width={18} height={18} />{plano.velocidade} de Upload</li>
              </ul>
              <div className="avulso-card__price">
                <span className="avulso-card__price-value">R$ {plano.precoInteiro},{plano.precoCentavos}</span>
                <span className="avulso-card__price-period">/mês</span>
              </div>
              {plano.nota && <p className="avulso-card__note">{plano.nota}</p>}
              <a
                href={buildWhatsAppPlanUrl(plano.velocidade)}
                target="_blank"
                rel="noreferrer"
                className="avulso-card__cta"
              >
                Contrate Já
              </a>
            </div>
          </div>
        ))}
      </div>
      {showViewAllLink && (
        <div className="avulsos-grid__footer">
          <Link to="/planos" className="avulsos-grid__link">Ver todos os planos e pacotes completos →</Link>
        </div>
      )}
    </>
  );
}

export default PlanosAvulsos;
